import { render, staticRenderFns } from "./IpsysHomeIndex.vue?vue&type=template&id=6f70cebc&scoped=true&"
import script from "./IpsysHomeIndex.vue?vue&type=script&lang=js&"
export * from "./IpsysHomeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70cebc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f70cebc')) {
      api.createRecord('6f70cebc', component.options)
    } else {
      api.reload('6f70cebc', component.options)
    }
    module.hot.accept("./IpsysHomeIndex.vue?vue&type=template&id=6f70cebc&scoped=true&", function () {
      api.rerender('6f70cebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/IpsysHomeIndex.vue"
export default component.exports